import joursFeries from "@socialgouv/jours-feries";

const isPublicHoliday = (public_holidays, date) => {
  return public_holidays.some((ph) => ph.setHours(0, 0, 0, 0) === date.setHours(0, 0, 0, 0));
}

const calculateGainByMonths = (ideal_inactive_timeseries, inactive_timeseries, sum_complete_timeseries, months) => {
  let sum_ideal_inactive = ideal_inactive_timeseries.filter((ts) => months.includes(new Date(ts.time).getMonth())).reduce((acc, ts) => acc + ts.value, 0);
  let sum_original_inactive = inactive_timeseries.filter((ts) => months.includes(new Date(ts.time).getMonth())).reduce((acc, ts) => acc + ts.value, 0);
  let difference_inactive = Math.round((sum_original_inactive - sum_ideal_inactive) * 10) / 10;
  let percentage = Math.round(difference_inactive / sum_complete_timeseries * 100 * 10) / 10;
  if (isNaN(percentage)) {
    percentage = 0;
  }
  return { percentage: percentage, value: difference_inactive }
}

const calculatePotentialGain = (timeseries, parameters) => {
  let public_holidays = [];
  if (!parameters.publicHolidays) {
    let years = new Set(timeseries.map((ts) => new Date(ts.time).getFullYear()));
    years.forEach((year) => {
      let ph = joursFeries(year);
      public_holidays = public_holidays.concat(Object.values(ph))
    });
  }

  let inactive_timeseries = timeseries?.filter((ts) => {
    let date = new Date(ts.time);
    let day = date.getDay();
    let dayOfWeek = day === 0 ? 6 : day - 1;
    let hour = date.getHours();
    return !parameters.daysOfWeek[dayOfWeek] || hour < parameters.hoursRange[0] || hour >= parameters.hoursRange[1] || isPublicHoliday(public_holidays, date);
  });

  let values = inactive_timeseries.map((ts) => ts.value);
  values.sort((a, b) => a - b);
  let centile_value = values[Math.min(Math.floor(parameters.centile * values.length), values.length - 1)];

  let sum_complete_timeseries = timeseries.reduce((acc, ts) => acc + ts.value, 0);

  let ideal_inactive_timeseries = inactive_timeseries.map((ts) => {
    return { time: ts.time, value: centile_value };
  });

  let gains = {
    total: calculateGainByMonths(ideal_inactive_timeseries, inactive_timeseries, sum_complete_timeseries, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
    // Summer according to ENEDIS is from 01/04 to 31/10 and winter is from 01/11 to 31/03
    summer: calculateGainByMonths(ideal_inactive_timeseries, inactive_timeseries, sum_complete_timeseries, [3, 4, 5, 6, 7, 8, 9]),
    winter: calculateGainByMonths(ideal_inactive_timeseries, inactive_timeseries, sum_complete_timeseries, [0, 1, 2, 10, 11]),
  }

  let optimized_complete_timeseries = timeseries.map((ts) => {
    if (inactive_timeseries.some((its) => its.time === ts.time)) {
      return { time: ts.time, value: centile_value };
    }
    return ts;
  });

  return { gains, optimized_complete_timeseries }
}


export { calculatePotentialGain };